export const SUPPORTED_YEARS = [2025, 2026, 2027, 2028, 2029, 2030];

export interface AnnualCellData {
  rating: number;
  moonPercent: number;
  gcHours: string;
}

export interface AnnualLocationData {
  id: string;
  name: string;
  country: string;
  latitude: number;
  longitude: number;
  cells: AnnualCellData[];
}

export interface AnnualYearData {
  year: number;
  saturdays: string[];       // e.g. ["Jan 3", "Jan 10", ...]
  locations: AnnualLocationData[];
}
